import { render, staticRenderFns } from "./modelManagement.vue?vue&type=template&id=767913ec&scoped=true&"
import script from "./modelManagement.vue?vue&type=script&lang=js&"
export * from "./modelManagement.vue?vue&type=script&lang=js&"
import style0 from "./modelManagement.vue?vue&type=style&index=0&id=767913ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767913ec",
  null
  
)

export default component.exports